'use strict';

frontendApp.factory('ExportDownloadService', ['ConfigService', 'TokenService', function (ConfigService, TokenService) {

  var _service = {};

  _service.getLink = function (project, exportObject) {
    if (!_.isUndefined(project) && !_.isUndefined(exportObject)) {
      return ConfigService.getServerBaseUrl() +
        "/project/" + project.id +
        "/export/" + exportObject.id +
        "/download" +
        "?client_id=" + ConfigService.getClientId() +
        "&access_token=" + TokenService.GetAccessToken();
    }
  };

  return _service;

}]);
